<div class="home-image" style="background-image: url(../assets/gpp-booth-2019.jpg)">
</div>
<div class="wrapper">
  <h1>Thank You For Supporting Great Plant Picks</h1>
</div><!-- wrapper -->
